module.exports = {
  global: {
    status: {
      done: '已完成',
      preview: '可预览',
      failed: '翻译失败',
      translation: '翻译中',
    },
    lang: {
      zh: '中文',
      en: '英语',
      ja: '日语',
    },
    down: {
      word: 'word下载',
      pdf: 'pdf下载',
      preview: '预览',
      read: '预览',
    },
  },
  tabNav: {
    online: '在线翻译',
    api: '翻译API',
    personal: '个人中心',
  },
  my: {
    nav: {
      doc: '我的文档',
      collection: '我的收藏',
      history: '我的历史',
      translator: '我的翻译',
      vip: '会员充值',
      personal: '个人中心',
    },
  },
  vip: {
    privileges: 'VIP 特权',
    des: [
      '海量文档翻译',
      '无限网页翻译',
      '尊贵标识',
      '更大词典',
    ],
    full: 'VIP充值',
    exchange: '彩云朵兑换',
    service: 'VIP服务协议',
    time: '有效期至 ',
    pay: '应付总额',
    paySure: '确认充值信息',
    payPoint: '确定使用彩云朵兑换VIP',
    sure: '确定',
    cancel: '取消',
    dealTitle: '彩云小译付费用户会员服务协议',
    PayOk: '确定支付',
    PayOver: '支付完成',
    PayError: '支付失败',
    PayPointOk: '兑换成功',
    PayPointErr: '兑换失败',
    topUpSuccess: '充值成功',
    topUpError: '充值失败',
    payMentComplete: '是否支付完成?',
    vipList: {
      pay: [
        '1个月',
        '3个月',
        '6个月',
        '一年',
      ],
      point: [
        '1天',
        '1周',
      ],
    },
  },
  doc: {
    nodata: '您还没有文档',
    tips: '提示',
    delete: '删除',
    deleteSuccess: '删除成功',
    deletefailed: '已取消删除',
    sure: '确 定',
    cancel: '取 消',
  },
  history: {
    nodata: '您还没有浏览历史',
  },
  translator: {
    nodata: '您还没有翻译',
    like: '获赞',
    nolike: '未获赞',
  },
  personal: {
    data: {
      tr: '翻译 ',
      like: '获赞 ',
      headshot: '头像',
      nickname: '昵称',
      upData: '更新资料',
    },
    upData: {
      ok: '更新成功',
      error: '更新失败',
    },
  },
  points: {
    details: '彩云朵明细',
    what: '什么是彩云朵',
    isWhat: '"彩云朵"是彩云小译注册用户在使用小译过程中所获得得积分，可用于兑换小译提供得网页翻译、VIP会员等增值服务。',
    computations: '彩云朵计算规则',
    add: '点击加载更多',
  },
  collection: {
    nodata: '您还没有收藏',
    alert: {
      message: '取消收藏?',
      sure: '确定',
      cancel: '取消',
      error: '取消收藏失败',
    },
  },
  share: {
    openLink: '打开原文',
    keptPrivate: '设为私密',
    sina: '新浪微博',
    weixin: '微信扫一扫',
  },
  header: {
    home: '主页',
    SignOut: '退出',
    register: '登陆 / 注册',
  },
  PayAgreement: {
    pange1: '彩云小译付费用户会员服务协议',
    pange2: '重要提示',
    pange3: '欢迎使用彩云小译付费会员（以下简称“付费会员”）服务，为了保障您的权益，请在使用付费会员服务之前，详细阅读此服务协议（以下简称“本协议”）所有内容，特别是加粗部分。未成年人则应在法定监护人陪同下阅读。 除非您已阅读并接受本协议所有条款，否则您无权使用付费会员服务。您对付费会员服务的购买和/或使用行为即视为您已阅读并同意接受本协议的约束。',
    pange4: '第一条 服务协议的接受和修订',
    pange5: '1.1 本协议内容包括协议正文、北京彩彻区明科技有限公司（以下简称“彩彻区明科技”）已经发布的或将来可能发布/更新的各类规则。所有规则均为本协议不可分割的组成部分，与协议正文具有同等法律效力，本协议正文与前述规则存在冲突的，以本协议正文为准。除另行明确声明外，您使用付费会员服务均受本协议约束。',
    pange6: '1.2 本协议及相关服务条款如由于业务发展需要进行修订的，彩彻区明科技将在彩云小译相关页面公布。您可前往查阅最新版协议条款。在彩彻区明科技修改上述条款后，如果您不接受修改后的条款，您可以选择终止使用付费会员服务。您继续使用本服务的，将被视为已接受了修改后的协议。',
    pange7: '第二条 定义',
    pange8: '2.1 付费会员：指彩彻区明科技为您提供的网络增值服务，您在成为付费会员后可以依本协议享有一定的特权优惠或参加活动，具体服务内容以彩彻区明科技提供的为准。付费会员的所有权和运营权，以及付费会员制度和活动的制订权均归彩彻区明科技所有，彩彻区明科技在法律规定的范围内拥有解释权',
    pange9: '2.2 “用户”或“您”：指享受彩彻区明科技提供的付费会员服务的个人或单一实体。',
    pange10: '第三条 成为付费会员的程序',
    pange11: '3.1 如您希望使用付费会员服务的，需先登录您的彩云帐号，或注册彩云帐号并登录。在成功登录彩云帐号的基础上，申请开通付费会员服务。如您选用其他第三方帐号登录彩云小译的，您应保证第三方帐号的稳定性、真实性以及可用性，如因第三方帐号原因（如第三方帐号被封号等）致使您无法登录彩云小译的，您应与第三方帐号的所属公司联系。您在使用付费会员服务时登录的彩云帐号是彩彻区明科技确认您身份的唯一依据。',
    pange12: '3.2 您可以在开通服务界面通过彩彻区明科技认可的支付方式完成支付来开通付费会员服务。您在开通服务时，应仔细核对帐号名称、开通服务类型与时长等具体信息。如因您个人原因造成充错帐号、开通错服务或时长，彩彻区明科技不予退还已收取的费用。',
    pange13: '第四条 付费会员资格的有关规定',
    pange14: '4.1 付费会员服务仅限于申请帐号自行使用，且不能在不同的彩云帐号之间转移。',
    pange15: '4.2 在已开通的付费会员有效期内，若您中途主动取消或终止付费会员资格的，将不会获得付费会员费用的退还。',
    pange16: '4.3 付费会员资格取消/终止后，您不再享有付费会员服务。',
    pange17: '第五条 付费会员使用规则',
    pange18: '5.1 您确认：您是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织，有能力对您使用付费会员服务的一切行为独立承担责任。若您不具备前述主体资格，彩彻区明科技在依据法律规定或本协议约定要求您承担责任时，有权向您的监护人或其他责任方追偿。若您是自然人，应向彩彻区明科技提供真实姓名、住址、电子邮箱、联系电话等信息；若您是法人或其他组织的，应提供名称、住址、联系人等信息。',
    pange19: '5.2 您应妥善保存有关帐号、密码，并对该帐号进行的所有活动和行为负责，禁止赠与、借用、租用、转让或售卖该帐号。您应自行负责妥善保管、使用、维护您在彩云小译申请取得的帐号、帐号信息及帐号密码。非彩彻区明科技原因致使您帐号密码泄漏以及因您保管、使用、维护不当造成损失的，彩彻区明科技无须承担与此有关的任何责任。',
    pange20: '5.3 如您实施了下列行为之一，彩彻区明科技有完全的权利在不通知您的情况下，终止提供付费会员服务，并有权限制、冻结或终止与该服务相关联的彩云帐号使用。彩彻区明科技无须给予任何补偿和退费，由此产生的责任由您自行独立承担。因此给彩彻区明科技或第三方造成损失的，您应负责全额赔偿：',
    pange21: '(1) 以营利为目的为自己或他人获得付费会员服务;',
    pange22: '(2) 将付费会员帐号以出租、出借、出售等任何形式提供给第三方使用;',
    pange23: '(3) 将通过付费会员服务获得的任何内容用于个人学习、研究或欣赏之外的用途;',
    pange24: '(4) 盗用他人彩云帐号进行付费会员注册或使用;',
    pange25: '(5) 以任何机器人软件、蜘蛛软件、爬虫软件、刷屏软件或其它非正规方式获得付费会员服务;',
    pange26: '(6) 通过不正当手段或以违反诚实信用原则的行为获得付费会员服务。',
    pange27: '5.4 如发生下列任何一种情形，彩彻区明科技有权根据实际情况，在不通知您的情况下中断或终止向您提供的一项或多项或全部服务，由此产生的损失由您承担，彩彻区明科技无需给与任何补偿和退费。若因此给彩彻区明科技或第三方造成损失的，您应负责全额赔偿：',
    pange28: '(1) 您提供的个人资料不真实或与注册时信息不一致又未能提供合理证明；',
    pange29: '(2) 经国家行政或司法机关的生效法律文书确认您存在违法或侵权行为，或者彩彻区明科技根据自身的判断，认为您的行为涉嫌违反本协议内容或彩彻区明科技不时公布的使用规则等内容，或涉嫌违反法律法规的规定的；',
    pange30: '(3) 您的行为干扰了彩云小译任何部分或功能的正常运行；',
    pange31: '(4) 您未经彩彻区明科技允许，利用彩云小译开展未经彩彻区明科技同意的行为，包括但不限于对通过彩云小译获得的信息进行商业化活动，如附加广告、商业内容或链接等；',
    pange32: '(5) 您的个人信息、发布内容等违反国家法律法规规定，有悖社会道德伦理、公序良俗、侵犯他人合法权益、政治色彩强烈，引起任何争议，或违反本协议、彩云小译平台公示的要求的;',
    pange33: '(6) 您利用彩云小译进行任何违法行为的。',
    pange34: '第六条 责任声明',
    pange35: '6.1 如果您行使本协议规定的权利而购买/接受彩彻区明科技以外的第三方商户提供的商品或服务，如因此发生纠纷的，您应向销售/提供该商品或服务的第三方商户主张权利，与彩彻区明科技无关。',
    pange36: '6.2 您须对您自身及您所邀请的宾客在参加彩云小译组织的活动或使用由彩云小译提供的各项优惠及增值服务时的实施的一切行为承担全部法律责任。',
    pange37: '6.3 彩彻区明科技不对您因第三方的行为或不作为造成的损失、不可抗力原因造成的损失承担任何责任，包括但不限于支付服务、网络接入服务、电信部门的通讯线路故障、通讯技术问题、网络、电脑故障、系统不稳定性、任意第三方的侵权行为等。',
    pange38: '6.4 您理解并同意，在使用付费会员服务的过程中，可能会遇到不可抗力等风险因素，使该服务发生中断。如出现上述情况，彩彻区明科技承诺将尽快与相关单位配合进行修复，但不承担由此对您造成的任何损失且不退还付费会员费用。',
    pange39: '第七条 其他约定',
    pange40: '7.1 服务中止、中断及终止：彩彻区明科技根据自身商业决策、政府行为、不可抗力等原因可能会选择中止、中断及终止付费会员服务。如有此等情形发生，彩彻区明科技会采取公告的形式通知您，但不承担由此对您造成的任何损失且不退还付费会员费用。',
    pange41: '7.2 法律与争议解决：本协议适用中华人民共和国的法律，并且排除一切冲突法规定的适用。如出现纠纷，您和彩彻区明科技一致同意将纠纷提交中国国际经济贸易仲裁委员会根据其现行有效的仲裁规则进行仲裁。仲裁裁决是终局的，对双方都有约束力。仲裁费用由败诉一方承担。',
    pange42: '7.3 彩彻区明科技不行使、未能及时行使或者未充分行使本协议或者按照法律规定所享有的权利，不应被视为放弃该权利，也不影响彩彻区明科技在将来行使该权利。',
    pange43: '7.4 如果您对本条款内容有任何疑问，请发送邮件至我们的客服邮箱：',
    pange44: '北京彩彻区明科技有限公司',
    pange45: '2017年10月31日',
  },
  fanyi: {
    toPersonal: '进入个人中心',
    button: '翻译',
    placeholder: '请输入要翻译的文字',
    upMessage: '支持docx, pdf格式文档中英互译，快来试用！',
    upbutton: '上传文档(Beta)',
    copyButton: '复制',
    isFileArr: ['上传中...', '翻译中'],
    isCopyArr: ['复制', '已复制', '复制失败'],
    progress: '已上传',
    pre_progress: '预览翻译进度',
    error: '错误',
    message: {
      format: '文件格式错误，请选择docx或pdf文件',
      c: '文件翻译失败，请重试',
      up_error: '文件上传失败，请重试',
      up_fail: '上传文档失败',
      changePdf: 'pdf全文预览失败,请下载word',
      ts_fail: '文档翻译转换失败',
      ts_no: '获取文档翻译状态有误，请重试',
      size_a: '请选择小于',
      size_b: 'M的文档',
      change_lang: '请选择翻译语言',
      ts_ok: '全文翻译已完成',
      xiaoyi_m: '小译正在为您努力翻译全文',
    },
    _translate: [
      '自动识别',
      '中文 » 英语',
      '英语 » 中文',
      '中文 » 日语',
      '日语 » 中文',
    ],
    downAllDoc: '下载全文',
  },
  read: {
    weixin: ['微信扫一扫：分享', '微信里点“发现”，扫一下', '二维码可分享至朋友圈'],
    over_button: '翻译完成，点击下载全文',
  },
  title: {
    all: '彩云小译 - ',
    mine: '个人中心',
    online: '在线翻译',
    doc: '文档翻译',
  },
  filebutton: {
    button: ['上传文档', '正在翻译中...'],
    text: ['中文  »  英语', '英语  »  中文', '中文  »  日语', '日语  »  中文'],
    message: '支持docx,pdf格式文档互译',
  },
  vipComponent: {
    pay: {
      friend: '邀请好友助力免费下载',
      friend1: '邀请 ',
      friend2: ' 位好友助力免费下载',
      money: '不差钱，付费下载文档',
      money1: '不差钱，付费 ',
      money2: '下载文档',
      money3: 'VIP ',
      money4: '折',
      money5: ' 元',
      vip: '开通会员，畅享海量文档下载',
      free1: '免费文档下载（还剩 ',
      free2: ' 次）',
      free: '免费下载（还剩 0 次）',
      freeOver: '免费下载次数已用完哦',
    },
    orderError: '订单生成失败',
    helpError: '助力失败',
    downOK1: '成功下载,您剩余的免费次数为',
    downOK2: '次',
    over: '您的免费体验次数已用完',
    userFree: '恭喜您，使用了一次免费下载文档的机会',
    tips: '本月VIP下载额度已用完',
  },
};


//////////////////
// WEBPACK FOOTER
// ./static/lang/zh.js
// module id = z8sE
// module chunks = 1